import React, { useEffect } from 'react'
import { RouteComponentProps } from '@reach/router'
import { PanelContent } from '../../../components/panel-content'
import { Button } from '../../../components/button'
import { useStateValue } from '../../../components/state'
import { MapFact } from '../../../components/map-fact'
import { useDelayedBoolean } from '../../../hooks/use-delayed-boolean'
import { Video } from '../../../components/video'
import { TextLink } from '../../../components/text-link'

export const GroundWaterReplenishment: React.FC<RouteComponentProps> = () => {
  const [, dispatch] = useStateValue()

  // Filter map pins to desalination
  useEffect(() => {
    dispatch({
      type: 'setActiveMarkerType',
      payload: { activeMarkerType: 'groundwater-replenishment' }
    })
  }, [dispatch])

  const factVisible = useDelayedBoolean({ delay: 500 })

  return (
    <PanelContent>
      <h1>Groundwater replenishment</h1>
      <p>
        An{' '}
        <TextLink href='https://www.watercorporation.com.au/Our-water/Groundwater/Groundwater-replenishment'>
          innovative concept
        </TextLink>{' '}
        where wastewater is treated to the highest drinking water standards,
        then recharged into our groundwater supplies. When it’s extracted years
        later, it’s treated again before arriving to your tap.
      </p>
      <p>
        Groundwater replenishment is one of the solutions that will help us
        become more climate resilient and secure our water supply for
        generations to come.
      </p>
      <Video videoId='7oVd9guE7Mw' />
      <MapFact
        aboveValue="Our plant in Craigie is the first full scale groundwater replenishment scheme in Australia. By 2060, this climate independent source could make up around 20% of Perth's water supply."
        visible={factVisible}
        position='bottom-right'
      />
      <Button href='/why'>Why groundwater replenishment?</Button>
    </PanelContent>
  )
}
